import React, {Component} from 'react';
import { Table } from 'antd';
import './index.less';

class OtherTable extends Component {
  render() {
    const { dataSource, columns } = this.props;
    return (
      <Table className="otherTable" dataSource={dataSource} columns={columns} pagination={false} />
    );
  }
}

export default OtherTable;
